export const ROUTE_DATA_CACHE_KEY = "routeDataCache";
export const ROUTE_FILTER_STATE_KEY = "routeFilterState";



// WEBPACK FOOTER //
// ./src/components/RouteStatus/utils/LocalStoragekeys.js